import { BoxProps, Flex, Header, Segment, ShorthandValue } from "@fluentui/react-northstar";
import React, { ReactNode } from "react";
import styles from "./segmentContent.module.scss";

export interface SegmentContentProps {
    children: ReactNode;
    style?: React.CSSProperties;
}

export const SegmentContent: React.FC<SegmentContentProps> = (props) => {
    return <Segment style={props.style} className={styles.container}>{props.children}</Segment>;
};
